import { NavigationGuard } from '@app/infrastructure/application/model/NavigationGuard';
import { createContext } from 'react';

export const NavigationGuardContext = createContext<NavigationGuard>({
    shouldGuard: false,
    setShouldGuard: () => {},
});
